import DealCard from './DealCard'

const EmptyState = ({ search, category }) => (
  <div className="col-span-full flex flex-col items-center justify-center py-28 text-center">
    <div className="text-7xl mb-5 select-none">🔍</div>
    <h3 className="text-xl font-display font-bold text-slate-700 mb-2">No deals found</h3>
    <p className="text-slate-400 text-sm max-w-xs">
      {search
        ? <>No results for <span className="font-semibold text-brand-600">"{search}"</span>. Try different keywords.</>
        : <>No deals in <span className="font-semibold">{category}</span> right now. Check back soon!</>
      }
    </p>
  </div>
)

/**
 * Responsive grid that renders all visible DealCards.
 * @param {{ deals: import('../data/deals').Deal[], search: string, category: string }} props
 */
const DealsGrid = ({ deals, search, category }) => (
  <section aria-label="Deals grid">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {deals.length === 0
        ? <EmptyState search={search} category={category} />
        : deals.map((deal, i) => (
            <DealCard key={deal.id} deal={deal} index={i} />
          ))
      }
    </div>
  </section>
)

export default DealsGrid
